import { Component, OnInit, Injector } from '@angular/core';
import { TenantDashboardServiceProxy, PaymentGatewayServiceProxy } from '@shared/service-proxies/service-proxies';
import { LazyLoadEvent } from 'primeng/api';
import * as moment from 'moment';
import { DashboardChartBase } from '../dashboard-chart-base';
import { WidgetComponentBase } from '../widget-component-base';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@app/store/TransactionDashboard/transactionDashboard.model';


class TransactionStats extends DashboardChartBase {

  totalPayoutAmount = 0; totalPayoutAmountCounter = 0;

  init(totalPayoutAmount) {
    this.totalPayoutAmount = totalPayoutAmount;
    this.hideLoading();
  }
}

@Component({
  selector: 'app-widget-payout-dashboard',
  templateUrl: './widget-payout-dashboard.component.html',
  styleUrls: ['./widget-payout-dashboard.component.css']
})
export class WidgetPayoutDashboardComponent extends WidgetComponentBase implements OnInit {

  transactionDataLength: number;
  transactionStats: TransactionStats;

  selectedDateRange: moment.Moment[] = [moment().add(-1, 'days'), moment().add(-1, 'day'), moment().subtract(7, 'days')];
  currencyCode;
  resTotalPayoutAmount;

  counter = 0;

  filterDays = [{
    name: 'Yesterday',
    value: 'yesterday'
  }, {
    name: 'Last 7 days',
    value: 'lastSevenDays'
  }]
  //dailySalesLineChart: DailySalesLineChart;

  selectedDate: string = this.selectedDateRange[0].format('L');

  yesterdayData$: Observable<any>;
  last7dayData$: Observable<any>;
  isYesterday: boolean = true;

  constructor(injector: Injector,
    private store: Store<{ transactionDashboardState: AppState }>) {
    super(injector);
    this.transactionStats = new TransactionStats();
    this.yesterdayData$ = store.select((state)=> state?.transactionDashboardState.yesterdayT);
    this.last7dayData$ = store.select((state)=> state?.transactionDashboardState.last7dayT);
  }

  ngOnInit() {
    this.fetchData(this.isYesterday);
  }

  fetchData(isYesterdayData: boolean) {
    this.resTotalPayoutAmount = 0; 
  
    const source$ = isYesterdayData ? this.yesterdayData$ : this.last7dayData$;
    const selectedDate = isYesterdayData
      ? this.selectedDateRange[0].format('L')
      : `${this.selectedDateRange[2].format('L')} - ${this.selectedDateRange[0].format('L')}`;
    
    source$.subscribe((res) => {
      if (res && res.length > 0) {
        const dailyList = res[0]?.dailyTransactionSummarizedList || [];
        this.transactionDataLength = dailyList.length;
        this.currencyCode = dailyList[0]?.currencyCode;

        dailyList.forEach(item => {
          if(item.currencyCode === this.currencyCode){
            this.resTotalPayoutAmount += item.totalPayoutAmount;
          }
        });
  
        this.transactionStats.init(this.resTotalPayoutAmount);
      } else {
        this.transactionDataLength = 0;
      }
    });
  
    this.selectedDate = selectedDate;
  }

  filterDaysChangeHandler(event: any){
    // the dropdown uses optionValue="value", so event.value is the plain string
    const selected = (event.value !== null && typeof event.value === 'object') ? event.value.value : event.value;
    this.isYesterday = selected === 'yesterday';
    this.fetchData(this.isYesterday);
  }
}

